import { useEffect, useState } from 'react';
import { readCookieCategories } from './categories';
export const useCookieConsent = () => {
    const [categories, setCategories] = useState(() => {
        return readCookieCategories();
    });
    useEffect(() => {
        const eventName = 'zapier.cookie-consent';
        const onConsentChanged = () => {
            setCategories(readCookieCategories());
        };
        window.addEventListener(eventName, onConsentChanged);
        return () => {
            window.removeEventListener(eventName, onConsentChanged);
        };
    });
    return categories;
};
//# sourceMappingURL=useCookieConsent.js.map
// @zapier/cookies@1.1.3 (6a0d73ece)
